module.exports = __webpack_public_path__ + "img/fingerprintok.d44264b4.png";